import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@salesforce/design-system-react';
import Svg from '../shared/Svg';
import './TimeBillingErrorsDisplay.scss';

const TimeBillingErrorsDisplay = ({ type, errorArray, isTooltipVisible, setTooltipVisible, toggleTooltip, hideCount, title, size, parent }) => {
  // color that is used for the icon fill on colored background
  const iconColor = () => {
    switch (type) {
      case 'error':
      case 'block-error':
        return '#ffffff';
      case 'warning':
        return '#000000';
      default:
        return '#000000';
    }
  };

  // color that is used for the icon fill on white background
  const iconFill = () => {
    switch (type) {
      case 'error':
      case 'block-error':
        return '#C23934';
      case 'warning':
        return '#FFB75D';
      default:
        return '#FFB75D';
    }
  };

  // path to the icon based on the type
  const iconPath = () => {
    switch (type) {
      case 'error':
        return 'assets/error.svg';
      case 'block-error':
        return 'assets/blockingError.svg';
      case 'warning':
      case 'block-warning':
        return 'assets/warning.svg';
      default:
        return 'assets/warning.svg';
    }
  };

  const tooltipAlignment = () => {
    switch (parent) {
      case 'TimeRecordItem':
        return 'top right';
      default:
        return type === 'error' ? 'bottom right' : 'bottom';
    }
  };

  useEffect(() => {
    const errorTooltip = document.getElementById('error-tooltip');
    const warningTooltip = document.getElementById('warning-tooltip');
    if (errorTooltip) {
      errorTooltip.style.backgroundColor = '#C23934';
    }
    if (warningTooltip) {
      warningTooltip.style.backgroundColor = '#FFB75D';
    }
  }, [isTooltipVisible]);

  const TooltipContent = () => {
    return (
      <div className={`time-errors-display-tooltip-container`}>
        <div className={`slds-callout slds-m-around_small time-errors-display-tooltip-titleContainer-${type}`}>
          <Svg
            className={`time-errors-display-tooltip-icon`}
            data={iconPath()}
            fill={iconColor()}
          />
          {title ?
            <p className='time-errors-display-tooltip-title'>{title}</p> :
            <p className='time-errors-display-tooltip-title'>
              Billing Rule {type === 'error' ? 'Error(s)' : 'Warning(s)'}
            </p>
          }
          <Svg
            className='time-errors-display-tooltip-close'
            data='assets/close.svg'
            fill={iconColor()}
            onClickAction={toggleTooltip}
          />
        </div>
        <ul className='slds-list_dotted time-errors-display-tooltip-list'>
          {errorArray.map((error, index) => {
            return (
              <li
                className='time-errors-display-tooltip-listItem slds-item'
                key={index}
              >
                {error}
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  return (
    <Tooltip
      id={type + '-tooltip'}
      align={tooltipAlignment()}
      content={<TooltipContent />}
      isOpen={isTooltipVisible}
    >
      <div
        className={`time-errors-display-container-${size || 'medium'} ${type}`}
        onClick={toggleTooltip}
      >
        <Svg
          className={`time-errors-display-icon-${size || 'medium'}`}
          data={iconPath()}
          fill={iconFill()}
        />
        {!hideCount && <p className='time-errors-display-count'>{errorArray.length}</p>}
      </div>
    </Tooltip>
  );
};

TimeBillingErrorsDisplay.propTypes = {
  type: PropTypes.string,
  errorArray: PropTypes.array,
  isTooltipVisible: PropTypes.bool,
  setTooltipVisible: PropTypes.func,
  toggleTooltip: PropTypes.func,
  hideCount: PropTypes.bool,
  title: PropTypes.string,
  size: PropTypes.string,
  parent: PropTypes.string,
};

export default TimeBillingErrorsDisplay;
